import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import statisticsImg from '../../../assets/images/statistics.svg';
import addProjectImg from '../../../assets/images/add-a-project.png';
import threeProposalsImg from '../../../assets/images/three-proposals.png';
import fireworksImg from '../../../assets/images/selected-fireworks.png';
import medalImg from '../../../assets/images/medal.svg';
import './HowCloraWorksForEmployers.scss';

const buttonText = (page) => {
  switch (page) {
    case 1:
      return 'Learn how Clora works';
    case 2:
      return 'Learn what to do first';
    default:
      return null;
  }
};

class HowCloraWorksForEmployers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
    };

    this.handleNextOrClose = this.handleNextOrClose.bind(this);
    this.renderBody = this.renderBody.bind(this);
  }

  handleNextOrClose(page) {
    const { handleCloseModal } = this.props;
    if (page <= 2) {
      this.setState({ page: page + 1 });
    } else {
      handleCloseModal();
    }
  }

  carouselIndicators(page) {
    return (
      <ol className="step-indicators">
        <li onClick={() => this.setState({ page: 1 })} className={page === 1 ? 'active' : ''} />
        <li onClick={() => this.setState({ page: 2 })} className={page === 2 ? 'active' : ''} />
        <li onClick={() => this.setState({ page: 3 })} className={page === 3 ? 'active' : ''} />
      </ol>
    );
  }

  renderBody() {
    const { page } = this.state;
    const {
      userFirstName, showDemo, addProjectPath, featuredConsultantsPath,
    } = this.props;
    switch (page) {
      case 1:
        return (
          <div className="text-center page-1">
            <div className="text-center">
              <h1 className="hero-header">
                {userFirstName ? `Welcome to Clora, ${userFirstName}!` : 'Welcome to Clora'}
              </h1>
            </div>
            <p className="body-text-1">
              Clora&#39;s tech platform is faster, more cost-efficient,
              and yields higher quality talent than traditional recruitment.
            </p>
            <img src={statisticsImg} className="img-responsive" alt="statistics" />
          </div>
        );
      case 2:
        return (
          <div className="page-2">
            <div className="text-center">
              <h1 className="hero-header">How does Clora work?</h1>
            </div>
            <Row>
              <Col xs={12} sm={4}>
                <img
                  src={addProjectImg}
                  className=" mb-3  img-responsive d-none d-sm-block add-projects-img"
                  alt="add projects"
                />
                <div className="page-2-list-item">
                  <div className="page-2-item-header body-text-1">1. Add a project</div>
                  <p className="body-text-1 ms-3 mt-5">
                    Tell us about your need and your account manager will contact you.
                  </p>
                </div>
              </Col>
              <Col xs={12} sm={4}>
                <img
                  src={threeProposalsImg}
                  className=" mb-3  img-responsive d-none d-sm-block three-proposals-img"
                  alt="three proposals"
                />
                <div className="page-2-list-item">
                  <div className="page-2-item-header body-text-1">2. Receive up to 3 proposals</div>
                  <p className="body-text-1 ms-3 mt-5">
                    Clora&#39;s industry experts vet high-fit,
                    top-tier candidates from global talent pools.
                  </p>
                </div>
              </Col>
              <Col xs={12} sm={4}>
                <img
                  src={fireworksImg}
                  className=" mb-3  img-responsive d-none d-sm-block fireworks-img"
                  alt="fireworks"
                />
                <div>
                  <div className="page-2-item-header body-text-1">3. Select the best fit!</div>
                  <p className="body-text-1 ms-3 mt-5">
                    Interview candidates you like and hire the best one.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        );
      case 3:
        return (
          <div className="page-3">
            <div className="text-center">
              <h1 className="hero-header">What can you do next at Clora?</h1>
            </div>
            <Row>
              <Col xs={12} sm={6}>
                <div className="add-project-container">
                  <a
                    href={addProjectPath}
                    className="btn btn-primary bigger-button how-clora-works-add-project"
                  >
                    Add Project
                  </a>
                  <h3 className="mt-4">If you know your project needs</h3>

                  <div className="explanation body-text-1">
                    Answer a few questions to create your first project
                    and wait for candidates!
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6} className="not-sure">
                <div className="body-text-1 top-consultants-container">
                  <img
                    src={medalImg}
                    className="img-responsive medal-img"
                    alt="medal"
                  />
                  <br />
                  <a
                    href={featuredConsultantsPath}
                    className="how-clora-works-top-consultants"
                    role="button"
                    tabIndex={0}
                  >
                    Browse Top Consultants
                  </a>
                  <h3 className="mt-4">If you aren&#39;t sure about your need</h3>
                  <div className="explanation body-text-1">
                    Browse Clora&#39;s top available consultants for mission-critical needs.
                  </div>
                </div>
              </Col>
            </Row>
            <div className="body-text-2 request-demo-prompt">
              If you want to know more about our services, we&#39;ll introduce you to Clora!
              <a
                onClick={() => showDemo()}
                className="how-clora-works-request-demo"
                role="button"
                tabIndex={0}
              >
                Request a demo
              </a>
            </div>
          </div>
        );
      default:
        return null;
    }
  }

  render() {
    const { page } = this.state;
    return (
      <div className="style-guide">
        <div>
          {this.renderBody()}
        </div>

        <div className="text-center">
          {page < 3
            && (
            <button
              className={`btn btn-primary bigger-button next-page-button how-clora-works-page-${page}-btn`}
              onClick={() => this.handleNextOrClose(page)}
            >
              {buttonText(page)}
            </button>
            )}
          {this.carouselIndicators(page)}
        </div>
      </div>
    );
  }
}

HowCloraWorksForEmployers.propTypes = {
  userFirstName: PropTypes.string,
  handleCloseModal: PropTypes.func.isRequired,
  showDemo: PropTypes.func.isRequired,
  addProjectPath: PropTypes.string.isRequired,
  featuredConsultantsPath: PropTypes.string.isRequired,
};

HowCloraWorksForEmployers.defaultProps = {
  userFirstName: null,
};

export default HowCloraWorksForEmployers;
